import { newToolFilterOAuthMcp } from "../oauth.ts";

export const canvaMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://static.canva.com/static/images/apple-touch-180x180-1.png",
  url: "https://mcp.canva.com/mcp",
  label: "Canva",
});
